// extracted by mini-css-extract-plugin
module.exports = {"final_sale_tag":"final-sale-tag_final_sale_tag__j4SVd","color_box":"final-sale-tag_color_box__M03dK"};